import {and} from '@edna/utils';

import {EPermission, EResellerIds, useGetTenantDataQuery, usePermission} from 'src/containers/User';

const useStripeOnetimePaymentEnabled = () => {
  const hasPermission = usePermission(EPermission.PERMISSION_STRIPE_ONETIME_INVOICE);

  return hasPermission;
};

const usePayKeeperOnetimePaymentEnabled = () => {
  const hasViewPermission = usePermission(
    and<EPermission>('PERMISSION_VIEW_PAYKEEPER', 'PERMISSION_VIEW_BILLING'),
  );

  const {data: tenantData} = useGetTenantDataQuery();

  return hasViewPermission && tenantData?.resellerId === EResellerIds.OSK_ID;
};

export {useStripeOnetimePaymentEnabled, usePayKeeperOnetimePaymentEnabled};
